// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"152":"b5a6530d","443":"c1168869","492":"c7cfa91d","937":"40ca89ee"}[chunkId] + ".js";
};